export default __webpack_public_path__ + "static/media/css.c5583d09.png";